import React from 'react'
import Picker from '../common/Picker'
import { translateRole } from '../../utils/translator'

const RolePicker = (props) => {

    const option = (role) => <span>{translateRole(role)}</span>

    return (
        <Picker
            {...props}
            option={option}
        />
    )
}

export default RolePicker